import { get } from '../ApiHandler/apihandler';
// import { toast } from 'react-toastify';
import { logoutAction } from '../../Redux/actions/authActions';

const fetchData = async (url, setUserData, dispatch, setIsLoading) => {
  try {
    setIsLoading(true);
    const response = await get(url);
    if (response.ok) {
      const data = await response.json();
      setUserData(data.data);
    } else if (response.status === 403) {
      setIsLoading(false);
      // toast.error('Session Timeout', {
      //   position: 'top-center',
      //   autoClose: 3000,
      //   hideProgressBar: true,
      //   closeOnClick: true,
      //   draggable: true,
      //   closeButton: false,
      // });
      dispatch(logoutAction());
    } else {
      setIsLoading(false);
      console.error('Failed to fetch user data');
    }
  } catch (error) {
    setIsLoading(false);
    console.error('Error:', error);
  } finally {
    setIsLoading(false);
  }
};

export default fetchData;
